import { render } from "./AdminCompanies.vue?vue&type=template&id=482c04f9&ts=true&lang=pug"
import script from "./AdminCompanies.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminCompanies.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__